import { ApplicationCogIcon } from './ApplicationCogIcon';

/**
 * author: Michael Irigoyen
 * id 38278159-AC2C-433A-9335-95B05C1F6F56
 * name application-cog
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-cog.svg
 * tags
 * - Settings 
 */
export const IframeCogIcon = ApplicationCogIcon;
export default IframeCogIcon